export default __webpack_public_path__ + "static/media/star.3de17c38.svg";